/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectiveActionDto
 */
export interface CorrectiveActionDto {
    /**
     * 
     * @type {number}
     * @memberof CorrectiveActionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CorrectiveActionDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CorrectiveActionDto interface.
 */
export function instanceOfCorrectiveActionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CorrectiveActionDtoFromJSON(json: any): CorrectiveActionDto {
    return CorrectiveActionDtoFromJSONTyped(json, false);
}

export function CorrectiveActionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectiveActionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CorrectiveActionDtoToJSON(value?: CorrectiveActionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
    };
}

